import { httpsCallable } from 'firebase/functions';
import { getApp } from 'firebase/app';
import { getFbFunctions } from './development';
import type { AgentToken } from './types/index.ts';

export async function addAgent(data: { name: string, type: string }) {
  const fbApp = getApp(this.firebaseApp);
  const functions = getFbFunctions(fbApp);

  try {
    const generateCustomToken = httpsCallable(functions, 'auth-generateCustomToken');
    const tokenData = (await generateCustomToken(data)).data as AgentToken;

    if (tokenData && tokenData.token) {
      return tokenData;
    } else {
      return null;
    }
  } catch {
    return null;
  }
}
